<script setup lang="ts">
// Behavioural port of AI SDK Elements' `Sources` (Apache-2.0, Copyright Vercel); anatomy only. See `source-types.ts`.

import { computed, ref, useId } from 'vue'
import AppSourcesContent from './AppSourcesContent.vue'
import AppSourcesTrigger from './AppSourcesTrigger.vue'
import type { SourceEntry } from './source-types'

const props = withDefaults(
  defineProps<{
    sources: SourceEntry[]
    defaultOpen?: boolean
  }>(),
  { defaultOpen: false },
)

defineEmits<{
  open: [slug: string]
}>()

const isOpen = ref(props.defaultOpen)
const triggerId = useId()
const contentId = useId()

const triggerAttrs = computed(() => ({
  id: triggerId,
  'aria-expanded': isOpen.value,
  'aria-controls': contentId,
}))

const contentAttrs = computed(() => ({ id: contentId, 'aria-labelledby': triggerId }))
</script>

<template>
  <section v-if="sources.length > 0" class="flex flex-col">
    <AppSourcesTrigger
      :sources="sources"
      :open="isOpen"
      :trigger-attrs="triggerAttrs"
      @toggle="isOpen = !isOpen"
    />

    <div class="collapsible" :data-state="isOpen ? 'open' : 'closed'">
      <div>
        <AppSourcesContent
          :sources="sources"
          :content-attrs="contentAttrs"
          @open="$emit('open', $event)"
        />
      </div>
    </div>
  </section>
</template>
